jQuery(document).ready(function($){
    var product_qty, product_price;

    $(document).on('click', 'button.single_add_to_cart_button, .woocommerce-variation-add-to-cart button[type="submit"], li.product.product-type-simple form button[type="submit"]', function (e) {
        e.preventDefault();

        let ajaxUrl = wc_ajax_add_to_cart.ajax_url;
        let nonce = wc_ajax_add_to_cart.wc_ajax_add_to_cart_nonce;
        let $thisbutton = $(this),
            $form = $thisbutton.closest('form.cart'),
            id = $thisbutton.val(),
            product_id = $form.find('input[name=product_id]').val() || id,
            variation_id = $form.find('input[name=variation_id]').val() || 0,
            title = wc_ajax_add_to_cart.added_text,
            product_title = $form.closest('li.product').find('.woocommerce-loop-product__title').text() || $form.closest('.product').find('h1.product_title').text() || 'no title';

        let productData = {
            addedText: wc_ajax_add_to_cart.added_text,
            addToCartButtonText:  wc_ajax_add_to_cart.to_cart,
            addToCartLink: wc_ajax_add_to_cart.cart,
            continueBtnText: wc_ajax_add_to_cart.continue_shopping,
            id: $form.find('input[name=product_id]').val() || id,
            img: null,
            price: null,
            priceText: wc_ajax_add_to_cart.price,
            quantity: null,
            quantityText: wc_ajax_add_to_cart.quantity,
            selectedVariation: $form.find('td.value label.current').text() || false,
            variationId: $form.find('input[name=variation_id]').val() || 0,
            variationText: wc_ajax_add_to_cart.var_text,
            title: $form.closest('li.product').find('.woocommerce-loop-product__title').text() || $form.closest('.product').find('h1.product_title').text() || 'no title',
        };


        if($thisbutton.closest('li.product').length > 0){

            if($thisbutton.closest('li.product').hasClass('product-type-variable')){
                productData.quantity = $thisbutton.closest('.single_variation_wrap').find('input[name="quantity"]').val() || 1;
                productData.price = $thisbutton.closest('.single_variation_wrap').find('.price .woocommerce-Price-amount').text();

                if($thisbutton.closest('.single_variation_wrap').find('.price').find('ins').length > 0){
                    productData.price = $thisbutton.closest('.single_variation_wrap').find('.price ins .woocommerce-Price-amount').text();
                }
            }else{
                productData.quantity = $thisbutton.closest('li.product').find('input[name="quantity"]').val() || 1;
                productData.price = $thisbutton.closest('li.product').find('.price .woocommerce-Price-amount').text();

                if($thisbutton.closest('li.product').find('.price').find('ins').length > 0){
                    productData.price = $thisbutton.closest('li.product').find('.price ins .woocommerce-Price-amount').text();
                }
            }
        }else{
            if($thisbutton.closest('div.product').hasClass('product-type-variable')){

                productData.quantity = $thisbutton.closest('.single_variation_wrap').find('input[name="quantity"]').val() || 1;
                productData.price = $thisbutton.closest('.single_variation_wrap').find('.price:last .woocommerce-Price-amount').text();

                if($thisbutton.closest('.single_variation_wrap').find('.price:last').find('ins').length > 0){
                    productData.price = $thisbutton.closest('.single_variation_wrap').find('.price:last ins .woocommerce-Price-amount').text();
                }
            } else {
                productData.quantity = $thisbutton.closest('form').find('input[name="quantity"]').val() || 1;
                productData.price = $thisbutton.closest('form').find('.price .woocommerce-Price-amount').text();

                if($thisbutton.closest('form').find('.price').find('ins').length > 0){
                    productData.price = $thisbutton.closest('form').find('.price ins .woocommerce-Price-amount').text();
                }
            }
        }

        const mainImage = $('.woocommerce-product-gallery__image img');
        const mainImagePlaceholder = $('.woocommerce-product-gallery__image--placeholder img');
        const relatedProductImage = $(this).parent().parent().parent().parent().find('img.attachment-woocommerce_thumbnail');
        const relatedProductPlaceholder = $(this).parent().parent().find('img.woocommerce-placeholder');
        const listViewImage = $(this).parent().parent().find('.woocommerce-loop-product__link img');


        if ( mainImage.length > 0 ) {
            productData.img = mainImage.eq(0)[0].outerHTML;
        } else if (mainImagePlaceholder.length > 0) {
            productData.img = mainImagePlaceholder.eq(0)[0].outerHTML;
        }

        // check if related product add to cart button clicked
        if ( relatedProductImage.length > 0 ) {
            productData.img = relatedProductImage[0].outerHTML;
        } else if ( relatedProductPlaceholder.length > 0 ) {
            productData.img = relatedProductPlaceholder[0].outerHTML;
        }

        // shop loop products image
        if ( listViewImage.length > 0 ) {
            productData.img = listViewImage[0].outerHTML;
        }


        const data = {
            action: 'wc_ajax_add_to_cart',
            product_id: productData.id,
            product_sku: '',
            quantity: productData.quantity,
            variation_id: productData.variationId,
            security: nonce,
        };

        $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

        setMiniCartLoadingState();

        $.ajax({
            type: 'post',
            url: ajaxUrl,
            data: data,
            beforeSend: function (response) {
                $thisbutton.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $thisbutton.addClass('added').removeClass('loading');
                $( document.body ).trigger( 'wc_fragments_loaded' );
            },
            success: function (response) {
                if (response.error & response.wc_ajax_add_to_cart) {
                    window.location = response.wc_ajax_add_to_cart;
                } else {
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);

                    addModal(productData, $('body'));
                }
            },
        });


        //Close pop-up
        $(document).on('click', function(event) {
            if (!$(event.target).closest('#add-to-cart-pup-up .popup-wrapper').length) {
                closeModal();
            }

            //@TODO need to off this event after modal closed;
        });

        $('body.woocommerce-wishlist, body.shop-archive, body.single-product').on('click', '#add-to-cart-pup-up .close, #add-to-cart-pup-up .popup-continue-shopping', function () {
            closeModal();
            //@TODO need to off this event after modal closed;
        });

        return false;
    });


    /**
     *
     */
    function addToCartAjaxVariations() {
        $(document).on( 'found_variation', function( e, v ){
            let id = $(e.target).find('.qty').attr('id');
            let form2 = $('#'+id).closest('form');
            let button = form2.find('button[type="submit"]');
            let variationData = form2.attr('data-product_variations');
            //let incart = $.parseJSON(button.attr('data-variations'));

            if (variationData) {
                let incart = $.parseJSON(variationData);
                if ( $.inArray(v.variation_id, incart) == -1 ){
                    button.removeAttr('disabled');
                    button.removeClass('incart');
                    button.html(incart_text.add_to_cart);
                } else {
                    button.attr('disabled', true);
                    button.addClass('incart');
                    button.html(incart_text.in_cart);
                    button.find('span').html(button.attr('data-in-cart'));
                }
            }
        });
    }

    addToCartAjaxVariations();

    $( document ).on('vet-filters-ajax-complete', function() {
        addToCartAjaxVariations();
    });


    /**
     * @description Close modal
     *
     * param {boolean} loading
     */
    function setMiniCartLoadingState(loading = true) {
        const loadingClass = 'loading';
        const minicartLink = $('.vet-mini-cart__link');

        if (loading) {
            minicartLink.addClass(loadingClass);
        } else {
            minicartLink.removeClass(loadingClass);
        }

    }


    /**
     * @description Close modal
     *
     */
    function closeModal() {
        $('#add-to-cart-pup-up').remove();
    }


    /**
     * @description Add modal
     *
     * @param {object} productData
     * @param {object} element
     *
     */
    function addModal(productData, element) {
        if ($('#add-to-cart-pup-up').length == 0) {
            sessionStorage.setItem('scrollTo', productData.id);

            let content = '<div id="add-to-cart-pup-up">';
            content += '<div class="popup-wrapper row">';
            content += '<div class="close"></div>';
            content += '<div class="popup-text">';
            content += '<p class="popup-title">' + productData.addedText + '</p>';
            content += '</div>';

            content += '<div class="popup-content">';
            //Featured image
            content += '<div class="popup-left__column">' + productData.img + '</div>';
            content += '<div class="popup-right_column">';
            content += '<div class="popup-product-info">';
            //Product name
            content += '<p class="popup-title">' + productData.title + '</p>';

            //product price container
            content += '<div class="pop-up-price__container">' + productData.priceText + ': ' + productData.price + '</div>';

            //product variation
            if ( productData.selectedVariation ) {
                content += '<div class="pop-up-variation__container">' + productData.variationText + ': <strong>' + productData.selectedVariation + '</strong></div>';
            }

            //Product quantity
            content += '<div class="pop-up-quantity__container">' + productData.quantityText + ': ' + '<strong>' + productData.quantity + '</strong></div>';
            content += '</div>';

            content += '<div class="popup-aditional-info">';

            content += '</div></div></div>';

            content += '<div class="popup-continue-shopping"><a class="vet-buttonx vet-buttonx--light">' + productData.continueBtnText + '</a></div>';
            content += '<div class="popup-cart-button"><a class="vet-buttonx vet-buttonx--primary" href="' + productData.addToCartLink + '">' + productData.addToCartButtonText + '</a></div>';
            content += '<div class="clearfix"></div></div></div>';

            element.append('<a href="#TB_inline?lang=en&inlineId=hidden_cart" id="show-hidden-cart" class="thickbox" style="display:none"></a>');
            element.append(content);
        }
    }

});

jQuery(function ($) {
    let scrollToId = sessionStorage.getItem('scrollTo');
    let element = $('li.product.post-' + scrollToId);

    if ( scrollToId != null && element.length > 0 && $('body.shop-archive').length > 0 ) {
        let elementHeight = element.height();
        let windowHeight = $(window).height();
        let offset = element.offset().top - (windowHeight / 2) - (elementHeight / 2);

        $([document.documentElement, document.body]).animate({
            scrollTop: offset
        }, 1000);
    }
    sessionStorage.removeItem('scrollTo');
});